import React, {useState, useEffect, useCallback} from 'react';

const Roof = (props) => {
  const [selectedarray,setSelectedArray ] = useState(-1)
  const [arrays,setArrays ] = useState(props.roofdata?.arrays??[])
  const [array,setArray] = useState({}) // This hold t he currently selected Array
  const [rooftype, setRoofType] = useState(props.roofdata?.rooftype??'')
  const [roofdescription,setRoofDescription] = useState(props.roofdata?.description??'')
  const [keeparraysame,setKeepSame] = useState(false)

  const updateParent = useCallback( () => {
    let nrd = JSON.parse(JSON.stringify(props.roofdata));
    nrd.description = roofdescription
    nrd.rooftype = rooftype
    nrd.arrays = arrays
    props.onChange(props.index, nrd)
  },[roofdescription,rooftype,arrays, props])

  useEffect(() =>{
    if(roofdescription !== props.roofdata.description ||
        rooftype !== props.roofdata.rooftype ||
        JSON.stringify(arrays) !== JSON.stringify(props.roofdata.arrays)
    )
      updateParent()
  },[roofdescription, rooftype,arrays, updateParent])

  useEffect(()=> {
    if(Object.keys(array).length > 0) {

      const numrows = array.numrows
      if(numrows !== array.rows.length ){
        let newrows = []
        for(let i=0; i<numrows; i++)
          newrows.push({nopanels: 0, orientation: ''})
        setArray((curarr) => ({...curarr, rows:newrows}) )
      }
    }
    console.log(`Arrays Debug`)
    console.log(arrays)
  },[array,setArray])

  useEffect(()=> {
    const srch = arrays.find(item=>item.index === array.index)
    if(srch) {
      const a1 = JSON.stringify(array)
      const a2 = JSON.stringify(srch)
      if(a1 !== a2 ) {
        setArrays((curarr)=> {
          return curarr.map((item,index) => {
            if(item.index === array.index)
              return array;
            return item;
          })
        })
      }
    }
  },[array,arrays,setArrays])

  const updateRoofType = (e) => {
    setRoofType(e.target.value)
  }

  const updateRoofDescription = (e) => {
    setRoofDescription(e.target.value)
  }

  const addArray = () => {
      setArrays((curarr) => [...curarr, { index: curarr.length, numrows:0, description: '', rows: [], roof: props.index}])
  }

  const updateArray = (arrindex,field,value) => {
    setArray((item) => ({...item,...{[field]:value}}))
  }

  const updateArrRow = (selarray,selindex,field,value) => {
      let updatedrows = array.rows.map((item,index)=> {

      if((index === selindex) || (keeparraysame && selindex===0) )
          return {...item,...{[field]:value}}
        return item;
      })
      setArray((curarr) => ({...curarr,rows:updatedrows}))
  }

  const updateSelectedArray = (index) => {
    setSelectedArray(index)
    const arr = arrays.find(item => item.index === index)
    if(arr)
      setArray(arr)
  }

    return (
      <div>
        <h2 style={{verticalAlign:'center'}}>Roof {props.index+1}{props.roofdata.description>''?<span style={{fontSize: '10pt',marginLeft: '10px'}}>({props.roofdata.description})</span>:''}</h2>
        <table>
          <tbody>
            <tr>
              <td>Number of Arrays on this Roof</td>
              <td>{(arrays??[]).length}</td>
            </tr>
            <tr><td>Roof Type</td>
            <td>
              <select id='rooftype' onChange={updateRoofType} value={rooftype}>
                  <option value="" >Select Roof Type</option>
                  <option value="plain">Plain Roof Tile</option>
                  <option value="pantile">Pantile Roof Tile</option>
                  <option value="pantileclay">Pantile Roof Tile (Clay)</option>
                  <option value="otherclay">Other Clay Tiles</option>
                  <option value="slate">Slate Roof Tile</option>
                  <option value="compslate">Composit Slate Roof Tile</option>
                  <option value="metaltile">Metal Roof Tile(s)</option>
                  <option value="metalsheet">Metal Roof Sheet</option>
                  <option value="flatroof">Flat Roof Roof Tubs</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>Description</td>
              <td><input type='text' value={roofdescription} onChange={updateRoofDescription} /></td>
            </tr>
          </tbody>
        </table><br/>
        <select id='arrayselect' value={selectedarray} onChange={(e) => updateSelectedArray(parseInt(e.target.value))} >
          <option value="-1">Select Roof Array</option>
          {(arrays??[]).map((array,index) => {
            return (
              <option key={`opt_arr_${props.index}_${index}`} value={array.index} >{`Array ${array.index+1}`}</option>
            )
          })}
        </select>
        <button type='button' onClick={addArray} style={{marginLeft: '10px'}}>Add A New Solar Array</button>
        {selectedarray >=0 &&
          <fieldset>
            <legend>Array {parseInt(selectedarray)+1}</legend>
            <table>
              <tbody>
                <tr>
                  <td>Number of Rows In this Array</td>
                  <td><input type='number' step='1' value={array.numrows??0}  placeholder='Number of Rows' onChange={(e)=> updateArray(selectedarray,'numrows',parseInt(e.target.value))}/></td>
                </tr>
                <tr>
                  <td>Array Description</td>
                  <td><input type='text'  value={array.description??""} placeholder='Array Description'  onChange={(e)=> updateArray(selectedarray,'description',e.target.value)}/></td>
                </tr>
              </tbody>
            </table>
            <br/>

        {((arrays??[]).find(item => item.index === selectedarray)?.rows??[]).length > 0 &&
        <>
        <br/>
        <h5>Set up Panels Per Row and Panel Orientation</h5>
        <input type='checkbox' checked={keeparraysame} onChange={(e) => setKeepSame(e.target.checked)} />&nbsp;Set All Rows the same as 1st
          <table>
            <thead>
              <tr>
                <th>Array</th><th>No Panels</th><th>Orientation</th>
              </tr>
            </thead>
            <tbody>
            {((arrays??[]).find(item => item.index === selectedarray)?.rows??[]).map((item,index) => (
              <tr>
                <td>{index+1}</td>
                <td><input type='number' value={item.nopanels} onChange={(e) => updateArrRow(selectedarray,index,'nopanels',e.target.value)} placeholder='No of Panels' style={{width: '100px', padding: '2px',border: '1px solid #ccc',  borderRadius: '2px'}} /></td>
                <td><select  value={item.orientation} onChange={(e) => updateArrRow(selectedarray,index,'orientation',e.target.value)} style={{padding: '2px', border: '1px solid #ccc', borderRadius: '4px'}}>
                      <option value="">Select Orientation</option>
                      <option value="portrait">Portrait</option>
                      <option value="landscape">Landscape</option>

                    </select>
                </td>
              </tr>
            ))
            }
            </tbody>
          </table>
          </>
        }
        </fieldset>
      }
      </div>
    )
}

export default Roof
